import React from "react";

import GovernanceExceptionQueue from "@/components/governance/GovernanceExceptionQueue";

const DDOExceptionQueue: React.FC = () => (
  <GovernanceExceptionQueue
    title="Exception Queue"
    roleScope="ddo"
    submissionPathPrefix="/ddo/submissions"
  />
);

export default DDOExceptionQueue;
